import Mock from './mock';
import apolloClient from '../../utils/apollo-client';
import { createEmployerEmbeddedUrl as mutation } from '../graphql/settlement';
import { getEnv } from 'ecx.saigon.ui.common';

export default async function openContractAgreement({ applicationId }) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.createEmployerEmbeddedUrl;
  }

  const response = await apolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: {
          applicationId
        }
      })
    );

  return response.data.createEmployerEmbeddedUrl;
}
